import {
  withStyles,
  WithStyles,
  Button,
  Typography,
  withWidth,
  WithWidth,
  CircularProgress,
  //ListItemText,
  Grid,
  makeStyles
} from '@material-ui/core'
import i18n from 'i18next'
import moment from 'moment'
// TODO
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ArrowRightIcon from 'mdi-react/ArrowDownIcon'
import { Fragment, useCallback, useState } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateStatusWithForm } from '../../../actions/apartments'
import { selectApplications } from '../../../actions/applications'
import { navigate } from '../../../actions/routes'
import {
  addShowingToFieldArray,
  createShowings
} from '../../../actions/showings'
import {
  RejectApplicationAction,
  OpenDialog,
  SelectApplicationsArray,
  CloseDialog,
  Navigate,
  UpdateStatusWithForm
} from '../../../actions/types'
import { CustomListWithCreditInfo } from '../../../components/Display/Lists'
//import { CustomList } from '../../../components/Display/Lists'
import { toast } from 'react-toastify'
import PhoneShow from '../../../components/PhoneShow/PhoneShow'
import customCloseIcon from '../../../images/customCloseIcon.svg'
// import { selectApartmentById } from '../../../selectors/apartments'
import {
  getApplicationsNameIdPairs,
  selectSelectedApplications
} from '../../../selectors/applications'
import {
  selectContentIdFromPathname,
  selectUserIdFromPathname
} from '../../../selectors/router'
import { MuiClasses } from '../../../types'
import { ApplicantAvailability } from '../../../types/applicantAvailability'
import {
  ApplicationUIData,
  ApplicationStatus,
  Application,
  MultiChoicePropKey,
  ApplicationListCase,
  LeadStatuses
} from '../../../types/applications'
import { AddShowingsFormData, Showing } from '../../../types/showings'
import { CreateShowingsFormState, StateInterface } from '../../../types/states'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import Suggest from '../../Apartment/Stepper/Steps/Suggest'
import Dialog from '../../Dialog'
import DirectCreationModal from '../../Showings/Create/DirectCreationModal'
//import SuggestTimeCard from '../../Showings/Reserve/SuggestTimeCard'
// import { getApplicationStatus } from '../values/handleApplicationsData'
import ApplicationCardButtons from './ApplicationCardButtons'
import ApplicationCardContent from './ApplicationCardContent'
import GuarantorPossibleBadge from './GuarantorPossibleBadge'
import { handleApplicationNameAndCreatedAt } from './helpers'
import applicationCardStyles from './styles'
import { Apartment } from '@dwellet/dwellet-utils'
// import SuggestTimeCard from "../../Showings/Reserve/SuggestTimeCard";
import { UserAttributes } from '../../../services/auth/types';
import { useHistory } from 'react-router-dom';
import apartmentsApi from '../../../services/apartments'
import applicationsApi from '../../../services/applications'
//import { useTranslation } from 'react-i18next';
import ContractInfoForm from './ContractInfoForm';

const additionalPropsOrder: ApplicationUIData = [
  'age',
  'movingWith',
  'movingWithAmount',
  'movingWithChildrenAmount',
  'movingWithDescription',
  'movingAbout',
  'pets',
  'petType',
  'readyForMoveDate',
  'lifeSituation',
  'lifeSituationCustom',
  'jobSeekerNote',
  'depositPaymentMethod',
  'depositPaymentMethodCustom',
  'depositPaymentDescription',
  'livelihood',
  'livelihoodDescription',
  'hasFinSSN',
  'creditStatus',
  'creditStatusNote',
  'guarantorPossible',
  'rentalDebts',
  'gender',
  'language',
  'notes',
  'spouseLifeSituation',
  'spouseLifeSituationCustom',
  'spouseJobSeekerNote',
  'spouseLivelihood',
  'spouseCreditStatus',
  'spouseCreditStatusNote'
]

const multiSelectPaths: { [key in MultiChoicePropKey]: string } = {
  age: 'application.age',
  gender: 'application.gender',
  lifeSituation: 'application.lifeSituation',
  movingWith: 'application.movingWith',
  depositPaymentMethod: 'application.depositPaymentMethod',
  language: 'application.language',
  spouseLifeSituation: 'newApplication.lifeSituationOptions',
  creditStatus: 'application.creditStatus',
  movingAbout: 'newApplication.movingAboutOptions',
  spouseCreditStatus: 'application.creditStatus'
}
export interface ApplicationCardProps extends WithStyles, WithWidth {
  rejectApplicationAction: RejectApplicationAction
  isSelected?: boolean
  isAdmin: boolean
  selectApplication: (id: string) => void
  chatWithApplicant: (applicationId: string) => void
  openDialog: OpenDialog
  closeDialog: CloseDialog
  t: i18n.TFunction
  application: Application
  apartment?: Apartment
  userAttributes?: UserAttributes
  listCase: ApplicationListCase
  disableActions: boolean
  allowInvitations: boolean
  availabilities: ApplicantAvailability[] | undefined
  showings?: Showing[]
}

interface StateProps {
  selectedApplications: string[]
  applicationNameIdPairs: any[] | undefined
  userId: string | undefined
}

interface DispatchProps {
  selectApplicationsAction: SelectApplicationsArray
  addShowingToFieldArray: (formData: AddShowingsFormData) => void
  createShowingsAction: (formData: CreateShowingsFormState) => Promise<unknown>
  navigate: Navigate
  updateStatusWithForm: UpdateStatusWithForm
}

type ComponentProps = ApplicationCardProps & StateProps & DispatchProps

const GetInfoButton = withStyles(() => ({
  root: {
    color: '#000000',
    fontSize: '1rem',
    background: '#FBF6EE',
    borderRadius: '0 0 6px 6px',
    padding: '12px 8px',
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    textTransform: 'none',
    transition: 'background-color 0.2s ease',
    '& svg': {
      marginLeft: '6px'
    },
    '&:hover': {
      backgroundColor: '#f4ede1'
    }
  }
}))(Button)

const useStyles = makeStyles({
  primaryBtn: {
    backgroundColor: '#4f9b44',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#3f7c36'
    }
  },
  lighGreenBtn: {
    backgroundColor: '#4f9b44',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#3f7c36'
    }
  },
  outlinedBtn: {
    backgroundColor: '#FFFFFF',
    color: '#000000',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      backgroundColor: '#f2f2f2',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
    }
  },
  phoneField: {
    boxSizing: 'border-box',
    marginTop: '10px',
    '& div': {
      paddingLeft: 0,
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  code: {
    position: 'absolute',
    right: '8px',
    fontSize: '0.9em',
    top: '4px',
    color: '#1a73e8',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
      color: '#0f5ac6'
    }
  },
  primaryBtnOutlined: {
    color: '#4f9b44',
    fontSize: '0.8125rem',
    backgroundColor: '#fff',
    padding: '7px',
    border: '1px solid #4f9b44',
    '&:hover': {
      color: '#3f7c36',
      backgroundColor: '#fff',
      border: '1px solid #3f7c36'
    }
  },
})

const SuggestModal = ({
  classes,
  t,
  dialogId,
  closeDialogAction,
  confirmDialogAction,
  rejectDialogAction
}: {
  classes: MuiClasses
  t: i18n.TFunction
  dialogId: string
  closeDialogAction: CloseDialog
  rejectDialogAction: () => Promise<void> // Assuming it's async
  confirmDialogAction: () => void
}) => {
  const [rejectIsLoading, setRejectIsLoading] = useState(false)

  const handleReject = async () => {
    setRejectIsLoading(true)
    try {
      await rejectDialogAction()
    } finally {
      closeDialogAction(dialogId)
      setRejectIsLoading(false)
    }
  }

  return (
    <Grid container justify="center" style={{ maxWidth: '800px', margin: 'auto' }}>
      <Typography variant="h5" align="center" className={classes.modalTitle}>
        {t('reject.label')}
      </Typography>
      <Grid item sm={12} style={{ margin: '15px 0 20px 0' }}>
        <Suggest isModal containerMaxWidth="100%" contentMaxWidth="100%" content={t('reject.confirmMessage')} />
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Button
            fullWidth
            className={classes.dialogSaveBtn}
            style={{ textTransform: 'uppercase' }}
            onClick={() => {
              confirmDialogAction()
              closeDialogAction(dialogId)
            }}
          >
            {t('application.inviteApplicant')}
          </Button>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Button
            variant="contained"
            fullWidth
            className={classes.primaryBtn}
            style={{ textTransform: 'uppercase' }}
            onClick={handleReject}
            disabled={rejectIsLoading} // Disable button when loading
          >
            {rejectIsLoading ? <CircularProgress size={24} color="inherit" /> : t('application.rejectAnyway')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

const SuggestCancelInvites = ({
  classes,
  t,
  dialogId,
  closeDialogAction,
  confirmDialogAction,
  rejectDialogAction
}: {
  classes: MuiClasses
  t: i18n.TFunction
  dialogId: string
  closeDialogAction: CloseDialog
  rejectDialogAction: () => void
  confirmDialogAction: () => void
}) => {
  return (
    <Grid
      container
      justify='center'
      style={{ maxWidth: '800px', margin: 'auto' }}
    >
      <Typography variant='h5' align='center' className={classes.modalTitle}>
        {t('applicantCard.cancelInvitations')}
      </Typography>
      <Grid item sm={12} style={{ margin: '15px 0 20px 0' }}>
        <Suggest
          isModal
          containerMaxWidth='100%'
          contentMaxWidth='100%'
          content={t('applicantCard.cancelInvitationsDisclaimer')}
        />
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Button
            variant='contained'
            fullWidth
            className={classes.primaryBtn}
            onClick={() => {
              confirmDialogAction()
              closeDialogAction(dialogId)
            }}
          >
            {t('applicantCard.cancelInvitations')}
          </Button>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Button
            fullWidth
            className={classes.dialogSaveBtn}
            style={{ textTransform: 'uppercase' }}
            onClick={() => {
              rejectDialogAction()
              closeDialogAction(dialogId)
            }}
          >
            {t('navigation.sub.back')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

const ApplicationCard = (applicationCardProps: ComponentProps) => {
  const {
    classes,
    selectApplication,
    chatWithApplicant,
    isSelected,
    rejectApplicationAction,
    application,
    apartment,
    userAttributes,
    openDialog,
    isAdmin,
    t,
    disableActions,
    selectApplicationsAction,
    userId,
    navigate,
    closeDialog,
    showings,
    availabilities,
    updateStatusWithForm
  } = applicationCardProps

  const {
    data,
    apartmentId,
    applicationId,
    status,
    applicants
  } = application
  const invitable =
    status === ApplicationStatus.created ||
    status === ApplicationStatus.noAvailableTimes ||
    status === ApplicationStatus.accepted

  const sortedAvailabilities =
    (availabilities || [])
      .slice()
      .sort((a, b) => moment(a.startTime).diff(moment(b.startTime)))
  const futureAvailabilities = sortedAvailabilities.filter(({ startTime }) =>
    moment(startTime).isAfter(moment())
  )
  const visibleAvailabilities =
    futureAvailabilities.length > 0
      ? futureAvailabilities
      : sortedAvailabilities

  const PhoneDisplay = (
    <PhoneShow
      application={application}
      shown={application.phoneShown}
      isAdmin={isAdmin}
    />
  )
  const history = useHistory();
  const moveToContractPage = () => {
    history.push("/generatecontract/" + application.code + "/steps/1", {
      application,
      apartment,
      userAttributes
    });
  }
  const [counter, setCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // Call this function to force a re-render
  const forceReRender = () => setCounter(counter => counter + 1);

  const cancelInvitations = async () => {
    const identifiers = { applicationId: application.applicationId, apartmentId: application.apartmentId }
    try {
      let response;
      if (application.documentId) {
        const documentId = application.documentId
        response = await applicationsApi.cancelDocument(identifiers, documentId)
      } else {
        response = await applicationsApi.cancelDocument(identifiers)
      }

      if (response.documentCancelled) {
        application.status = ApplicationStatus.wantsContract
        forceReRender()
        const message = t('applicantCard.invitationsCancelled')
        toast.info(message, { autoClose: 25000 })
      } else {
        const message = t('applicantCard.invitationsNotCancelled')
        toast.info(message, { autoClose: 25000 })
      }
    } catch (error) {
      //console.error(error)
    }
  }

  const applicationCardButtonsProps = {
    t,
    isSelected,
    application,
    selectApplication,
    chatWithApplicant,
    openDialog,
    closeDialog,
    invitable,
    disableActions,
    PhoneDisplay,
    status,
    updateStatusWithForm,
    navigate,
    isAdmin,
    moveToContractPage,
    cancelInvitations,
    apartment
  }

  const hideListItemLogic = (key: string, applicationAnswer: string) =>
    !applicationAnswer ||
    applicationAnswer === 'noAnswer' ||
    applicationAnswer === 'myAnswer' ||
    (key === 'lifeSituation' && applicationAnswer === 'other') ||
    (key === 'guarantorPossible' && applicationAnswer === 'no') ||
    (key === 'pets' && applicationAnswer === 'yes') ||
    (key === 'depositPaymentMethod' && applicationAnswer === 'myAnswer') ||
    (key === 'depositPaymentMethod' && applicationAnswer === 'other')

  const { name, createdAtString } = handleApplicationNameAndCreatedAt(
    application,
    t
  )

  const sendContractInfoRequest = async (application: Application, apartment: Apartment) => {
    setIsLoading(true)
    try {
      await apartmentsApi.sendContractInfoRequest(application, apartment)
      const message = t('applicantCard.contractInfoRequestSent')
      toast.info(message, { autoClose: 25000 })
      closeDialog(`getMoreInfoDialog-${applicationId}`)
    } catch (error) {
      //console.error(error)
      const message = t('applicantCard.contractInfoRequestFailed')
      toast.info(message, { autoClose: 25000 })
    } finally {
      setIsLoading(false)
    }
  }

  const inviteApplicant = () => {
    navigate(`/users/${userId}/apartments/${apartmentId}/showings`)
  }

  const handleInviteApplicantClick = useCallback(() => {
    closeDialog(`getMoreInfoDialog-${applicationId}`)
    inviteApplicant()
  }, [apartmentId, applicationId, closeDialog, navigate, userId])

  const myClasses = useStyles()

  const [showContractInfoForm, setShowContractInfoForm] = useState(false);
  // const incompleteProfile =
  //   leadId &&
  //   partnerLead &&
  //   partnerLead.status !== LeadStatuses.profileCompleted

  return (
    <Fragment>
      <div className={classes.card}>
        {isAdmin && application.code && (
          <a
            className={myClasses.code}
            href={`/reserve/${application.code}`}
            target='_blank'
            rel='noreferrer noopener'
          >
            {application.code}
          </a>
        )}
        <ApplicationCardContent
          {...applicationCardProps}
          name={name}
          createdAtString={createdAtString}
          showings={showings}
        />
        {application?.data?.guarantorPossible === 'yes' && (
          <GuarantorPossibleBadge {...applicationCardProps} />
        )}
        <ApplicationCardButtons {...applicationCardButtonsProps} />
        {/* {!incompleteProfile && ( */}
        <GetInfoButton
          color='primary'
          onClick={() => {
            selectApplicationsAction([applicationId])
            openDialog(`getMoreInfoDialog-${applicationId}`)
          }}
        >
          {t('general.getMoreInfo')} <ArrowRightIcon />
        </GetInfoButton>
        {/* )} */}
      </div>
      <Dialog
        buttonVariant='outlined'
        dialogId={`rejectDialog-${applicationId}`}
        noOpenDialogButton
        Content={
          <SuggestModal
            classes={classes}
            t={t}
            dialogId='stopLeavingFromPageApplication'
            rejectDialogAction={() => {
              rejectApplicationAction({ apartmentId, applicationId })
            }}
            confirmDialogAction={inviteApplicant}
            closeDialogAction={closeDialog}
          />
        }
        customCloseIcon={customCloseIcon}
        borderRadius='10px'
        maxWidth='md'
      />
      <Dialog
        buttonVariant='outlined'
        dialogId={`cancelInvitationsDialog-${applicationId}`}
        noOpenDialogButton
        Content={
          <SuggestCancelInvites
            classes={classes}
            t={t}
            dialogId='stopLeavingFromPageApplication'
            rejectDialogAction={closeDialog}
            confirmDialogAction={cancelInvitations}
            closeDialogAction={closeDialog}
          />
        }
        customCloseIcon={customCloseIcon}
        borderRadius='10px'
        maxWidth='md'
      />

      {/* <Dialog
        dialogId={`rejectDialog-${applicationId}`}
        noOpenDialogButton
        confirmLabel={t('application.inviteApplicant')}
        closeLabel={t('application.rejectAnyway')}
        beforeCloseDialogAction={() =>
          rejectApplicationAction({ apartmentId, applicationId })
        }
        confirmDialogSubmitAction={() => inviteApplicant()}
        customCloseIcon={customCloseIcon}
        borderRadius='20px'
        customButtonContainerClassName={classes.buttonContainerClassName}
        customButtonConfirmClassName={classes.buttonConfirmClassName}
        customButtonCloseClassName={classes.buttonCloseClassName}
        noFreeSpace
        Content={
          <GridContainer className={classes.suggestDialogContainer}>
            <Typography className={classes.titlePopup} variant='h5'>
              {t('reject.label')}
            </Typography>
            <Suggest classes={classes} content={t('reject.confirmMessage')} />
          </GridContainer>
        }
      /> */}
      <Dialog
        dialogId={`getMoreInfoDialog-${applicationId}`}
        title={t('application.applicationInfo')}
        noOpenDialogButton
        fullScreenDialogMobile={true}
        Content={
          <Fragment>
            <Typography
              variant='h3'
              className={classes.applicantName}
            >{`${name}`}</Typography>

            <CustomListWithCreditInfo
              t={t}
              translationPath='application.list.'
              data={data}
              applicants={applicants}
              multiSelectPaths={multiSelectPaths}
              informationOrder={additionalPropsOrder}
              hideListItemLogic={hideListItemLogic}
              capitalizeFirstLetter={true}
            />

            {visibleAvailabilities.length > 0 && (
              <div className={classes.proposedTimesContainer}>
                <Typography variant='h5' className={classes.proposedTimesTitle}>
                  {t('application.proposedTimes')}
                </Typography>
                <div className={classes.proposedTimesList}>
                  {visibleAvailabilities.map((availability) => (
                    <div
                      key={availability.applicantAvailabilityId}
                      className={classes.proposedTimesItem}
                    >
                      <Typography
                        variant='body2'
                        className={classes.proposedTimesDate}
                      >
                        {moment(availability.startDate).format('dd D.M.')}
                      </Typography>
                      <Typography
                        variant='body2'
                        className={classes.proposedTimesTime}
                      >
                        {`${moment(availability.startTime).format(
                          'HH:mm'
                        )} - ${moment(availability.endTime).format('HH:mm')}`}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* <div className={classes.line} /> */}
            {(invitable) && (
              <Fragment>
                <Grid item xs={12} style={{ marginBottom: '1rem', marginTop: '0.5rem' }}>
                  <Button
                    className={myClasses.primaryBtn}
                    fullWidth
                    variant='contained'
                    color='primary'
                    onClick={handleInviteApplicantClick}
                  >
                    {t('application.inviteApplicant')}
                  </Button>

                  {/* <div className={myClasses.phoneField}>
                    <Typography variant='body2' color='textSecondary'>
                      {t('application.headings.phone')}
                    </Typography>
                    {PhoneDisplay}
                  </div> */}
                </Grid>
              </Fragment>
            )}
            {window.talkSession && (
              <Fragment>
                <Grid item xs={12} style={{ marginBottom: '1rem', marginTop: '0.5rem' }}>
                  <Button
                    className={myClasses.lighGreenBtn}
                    fullWidth
                    variant='contained'
                    color='primary'
                    onClick={() => chatWithApplicant(applicationId)}
                  >
                    {t('general.chat')}
                  </Button>
                </Grid>
              </Fragment>
            )}
            {application.applicants && application.status === ApplicationStatus.wantsContract && (
              <Fragment>
                <div className={classes.line} />
                <Grid item xs={12}>
                  <Button
                    className={myClasses.primaryBtn}
                    fullWidth
                    variant='contained'
                    color='primary'
                    onClick={() => moveToContractPage()}
                  >
                    {t('applicantCard.generateContract')}
                  </Button>
                </Grid>
              </Fragment>
            )}

            {application?.status === ApplicationStatus.wantsContract && (
              <Fragment>
                <Grid item xs={12} style={{ marginBottom: '1rem', marginTop: '0.5rem' }}>
                  <Button
                    className={myClasses.outlinedBtn}
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleInviteApplicantClick}
                  >
                    {t('application.inviteApplicant')}
                  </Button>
                </Grid>
              </Fragment>
            )}

            {application.applicants && application.status === ApplicationStatus.wantsContract && (
              <Fragment>
                <div className={classes.line} />
                <Grid item xs={12}>
                  <Button
                    className={myClasses.outlinedBtn}
                    fullWidth
                    variant='contained'
                    color='primary'
                    onClick={() => openDialog(`rejectDialog-${applicationId}`)}
                  >
                    {t('applicantCard.reject')}
                  </Button>
                </Grid>
              </Fragment>
            )}

            {application.applicants && application.status === ApplicationStatus.invitationsSent && (
              <Fragment>
                <div className={classes.line} />
                <Grid item xs={12}>
                  <Button
                    className={myClasses.primaryBtn}
                    fullWidth
                    variant='contained'
                    color='primary'
                    onClick={() => openDialog(`cancelInvitationsDialog-${applicationId}`)}
                  >
                    {t('applicantCard.cancelInvitations')}
                  </Button>
                </Grid>
              </Fragment>
            )}
            {/* {(invitable || (!application.applicants && ApplicationStatus.wantsContract)) && ( */}
            {!application.applicants && (
              <div style={{ marginTop: '-25px', marginBottom: '10px' }}>
                <Suggest
                  isModal
                  containerMaxWidth='100%'
                  contentMaxWidth='100%'
                  content={t('applicantCard.sendContractInfoRequestDisclaimer')}
                />
              </div>
            )}
            {!application.applicants && (
              <Fragment>
                <Grid item xs={12} style={{ marginTop: '8px' }}>
                  <Button
                    disabled={isLoading} // Disable when loading
                    className={myClasses.primaryBtn}
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => sendContractInfoRequest(application, apartment)}
                  >
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : t('applicantCard.requestContractInfo')}
                  </Button>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '8px' }}>
                  <Button
                    className={myClasses.outlinedBtn}
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => openDialog(`rejectDialog-${applicationId}`)}
                  >
                    {t('applicantCard.reject')}
                  </Button>
                </Grid>
              </Fragment>
            )}
            {isAdmin && (
              <Fragment>
                <Grid item xs={12} style={{ marginTop: '8px' }}>
                  <Button
                    className={myClasses.primaryBtnOutlined}
                    fullWidth
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setShowContractInfoForm(!showContractInfoForm);
                      if (!showContractInfoForm) {
                        setTimeout(() => {
                          document.getElementById("contractInfoForm").scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                          });
                        }, 0);
                      }
                    }}
                  >
                    {t('applicantCard.addContractInfo')}
                  </Button>
                </Grid>
                {showContractInfoForm && (
                  <Grid item xs={12} style={{ marginTop: '16px' }}>
                    <div id="contractInfoForm">
                      <ContractInfoForm application={application} apartment={apartment} />
                    </div>
                  </Grid>
                )}
              </Fragment>
            )}

          </Fragment>
        }
      />
      <Dialog
        noOpenDialogButton
        dialogId={`createViewingDirectly-${applicationId}`}
        Content={<DirectCreationModal application={application} t={t} />}
        customCloseIcon={customCloseIcon}
        borderRadius='10px'
        maxWidth='sm'
        fullScreenDialogMobile={true}
      />
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)

  return {
    selectedApplications: selectSelectedApplications(state),
    userId: selectUserIdFromPathname(state),
    applicationNameIdPairs: apartmentId
      ? getApplicationsNameIdPairs(apartmentId, state)
      : undefined
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectApplicationsAction: (applicationIdArray: string[]) =>
    dispatch(selectApplications(applicationIdArray)),
  addShowingToFieldArray: bindSubmitActionToPromise(
    dispatch,
    addShowingToFieldArray
  ),
  navigate: (path: string) => dispatch(navigate(path)),
  createShowingsAction: bindSubmitActionToPromise(dispatch, createShowings),
  updateStatusWithForm: bindSubmitActionToPromise(
    dispatch,
    updateStatusWithForm
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withWidth()(
    withStyles(applicationCardStyles, { withTheme: true })(ApplicationCard)
  )
)
